export default "__VITE_ASSET__BAM2cT23__"